import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans Regular"),
         url("/fonts/SharpSans.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: block;
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans Medium"),
         url("/fonts/Medium.otf") format("opentype");
    font-weight: 500;
    font-style: normal;
    font-display: block;
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans SemiBold"),
         url("/fonts/SemiBold.otf") format("opentype");
    font-weight: 600;
    font-style: normal;
    font-display: block;
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans Bold"),
         url("/fonts/Bold.otf") format("opentype");
    font-weight: 700;
    font-style: normal;
    font-display: block;
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans ExtraBold"),
         url("/fonts/ExtraBold.otf") format("opentype");
    font-weight: 800;
    font-style: normal;
    font-display: block;
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  * {
    font-family: "Sharp Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeSpeed;
    font-feature-settings: "kern" 1;
  }

  /* Prevent layout shifts during font loading */
  body {
    font-synthesis: none;
    text-size-adjust: 100%;
  }

  /* Ensure tooltips and overlays don't cause layout shifts */
  [data-tooltip] {
    contain: layout;
  }
`;

export default GlobalStyles;
